import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import img_close from '@/resources/assets/images/ic_close.png';
import { getLocaleWordContent } from '@/utils/language.util';

function TermFirst({ setPopUp }) {
     
    const divStyle = {
        overflowY: 'auto',   // 세로 스크롤을 허용
        maxHeight: '500px',  // 최대 높이 설정 (스크롤이 필요한 경우에만 나타나게 함)
        border: '1px solid #ccc', // 선택적으로 테두리를 추가할 수 있음
      };

      
    return (
        <div className="popup_01 popup_term1">
            <div className="popup_inner01" style={divStyle}>
                <div className="popup_header">
                    <h3>이용약관</h3>
                    <img src={img_close} className="popup_close" alt="close" onClick={() => setPopUp(0)} />
                </div>
                <div>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>1</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>목적</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>이 약관은 </span>
    <span style={{ fontFamily: "Arial", backgroundColor: "#ffffff" }}>(</span>
    <span style={{ backgroundColor: "#ffffff" }}>주</span>
    <span style={{ fontFamily: "Arial", backgroundColor: "#ffffff" }}>)</span>
    <span style={{ backgroundColor: "#ffffff" }}>메가아즈위</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}> </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>이하</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>: </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>회사</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>가 제공하는 </span>
    <span style={{ fontFamily: "Arial", backgroundColor: "#ffffff" }}>
      Aleo
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>서비스</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>이하</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>: </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>서비스</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      의 이용조건 및 절차에 관한 회사와 회원 간의 권리 의무 및 책임사항
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      기타 필요한 사항을 규정함을 목적으로 합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>2</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>약관의 명시</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>설명과 개정</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        이 약관의 내용은 회사의 서비스 회원가입 관련 사이트에 게시하거나 기타의
        방법으로 이용자에게 공지하고
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        이용자가 회원으로 가입하면서 이 약관에 동의함으로써 효력을 발생합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>회사는 </span>
      <span>"</span>
      <span style={{ fontFamily: "굴림" }}>약관의 규제에 관한 법률</span>
      <span>", "</span>
      <span style={{ fontFamily: "굴림" }}>
        정보통신망 이용촉진 및 정보보호 등에 관한 법률
      </span>
      <span>", "</span>
      <span style={{ fontFamily: "굴림" }}>
        특정 금융거래정보의 보고 및 이용 등에 관한 법률
      </span>
      <span>" </span>
      <span style={{ fontFamily: "굴림" }}>
        등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사가 약관을 개정할 경우에는 적용일자 및 개정 사유를 명시하여 현행
        약관과 함께 회사 사이트의 초기화면이나 팝업화면 또는 공지사항으로 그
        적용일자{" "}
      </span>
      <span>7</span>
      <span style={{ fontFamily: "굴림" }}>일 이전부터 공지합니다</span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>다만</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회원에게 불리하거나 중대한 내용의 변경의 경우에는 적용일자{" "}
      </span>
      <span>30</span>
      <span style={{ fontFamily: "굴림" }}>
        일 이전에 회원에게 공지 및 개별 통지합니다
      </span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사가 전항에 따라 개정약관을 공지하면서 회원에게{" "}
      </span>
      <span>7</span>
      <span style={{ fontFamily: "굴림" }}>
        일간의 기간 내에 의사 표시를 하지 않으면 의사표시가 표명된 것으로 본다는
        뜻을 명확하게 공지하였음에도 회원이 명시적으로 거부의 의사표시를 하지
        아니한 경우 회원이 개정약관에 동의한 것으로 봅니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회원이 개정약관의 적용에 동의하지 않는다는 명시적 의사를 표명한 경우
        회사는 개정 약관의 내용을 적용할 수 없으며
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        이 경우 회원은 이용계약을 해지할 수 있습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>다만</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 회사는 이용계약을
        해지할 수 있습니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>3</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>약관 외 준칙</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      서비스 이용과 관련하여는 이 약관을 우선 적용하며
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이 약관에서 정하지 않은 사항은 관계 법령 또는 상 관례 따릅니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>4</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>용어의 정의</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이 약관에서 사용하는 용어의 정의는 다음과 같습니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      className="ListParagraph"
      style={{
        marginLeft: "33.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>회원</span>
      <span>: </span>
      <span style={{ fontFamily: "굴림" }}>
        이 약관을 승인하고 회원가입을 하여 회사와 서비스 이용계약을 체결한 자를
        말합니다
      </span>
      <span>.</span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "33.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>아이디</span>
      <span>(ID): </span>
      <span style={{ fontFamily: "굴림" }}>
        회원의 식별과 서비스 이용을 위하여 회원이 등록하는 전자우편 주소 또는
        휴대전화 번호를 말합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "33.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>비밀번호</span>
      <span>: </span>
      <span style={{ fontFamily: "굴림" }}>
        회원의 동일성 확인과 회원정보의 보호를 위하여 회원이 회사가 승인한
        문자와 숫자의 조합대로 설정한 것을 말합니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>5</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이용계약의 성립
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에
        동의한다는 의사표시를 함으로서 회원가입을 신청합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회원가입은 회사의 승낙이 회원에게 도달한 시점으로 합니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>
        회사는 다음 각 호의 경우 승낙을 거절하거나 유보할 수 있습니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span
      style={{ fontFamily: "Arial", fontSize: "10.5pt", AwImport: "ignore" }}
    >
      &nbsp;
    </span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>1.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      실명이 아니거나 타인의 명의를 사용하여 신청한 경우
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>2.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      허위 정보를 기재하여 신청한 경우
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>3.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      고객 확인을 위한 서류 제출 등 관계 법령에서 정한 요건을 이행하지 않은 경우
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>4.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회사가 정한 이용신청요건에 미비한 부분이 있었을 때
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>5.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      설비에 여유가 없거나 기술상 장애가 있는 등 회사의 사정상 승낙이 곤란한
      경우
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>6.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>7.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이용 계약은 회원
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>ID </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      단위로 체결합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>. </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이용계약이 성립되면
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이용신청자는 회원으로 등록됩니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>8.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      실명이 아니거나 타인의 이름
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      전화번호 등의 개인정보를 도용하여 허위 가입한 회원은 법적인 보호를 받을 수
      없으며
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이에 따른 민사
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      형사상의 모든 책임은 가입한 회원이 져야 합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>9.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>만 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>19</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      세 미만은 회사에서 제공하는 가상자산 거래 관련 서비스 이용을 제한합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>10.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이용자가 국제자금세탁방지기구
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>
      (FATF, Financial Action Task Force)
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      에서 발표한 국제기준 미이행
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>∙</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      비협조 국가 또는 지역의 국민
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>시민권자</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>영주권자</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      거주자 등인 경우 서비스 이용이 제한될 수 있으며
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회원은 다음 각 호를 보증합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>11.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      국제기준 미이행
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>∙</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      비협조 국가의 국민
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>시민권자</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>영주권자</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      거주자 등이 아닐 것
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>12.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      국제기준 미이행
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>∙</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      비협조 국가 체류 중에 서비스를 이용하지 않을 것
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>13.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>1</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      항에 따른 신청에 있어 회사는 관계 법령에 의하여 전문기관을 통한 고객확인
      및 본인인증을 요청할 수 있습니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>. </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>만일</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이러한 회사의 제공 요청을 거부하여 이용자의 신원이 확인되지 않아 발생하게
      되는 불이익에 대하여 회사는 책임을 지지 않습니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>6</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회원정보 사용에 대한 동의
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 회원의 개인정보를 서비스 제공 등 이용계약의 이행을 위한 목적으로
        이용합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회원이 회사 및 회사와 제휴한 서비스들을 편리하게 이용할 수 있도록 하기
        위해 회원 정보는 회사와 제휴한 업체에 제공될 수 있습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>단</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회사는 회원 정보 제공 이전에 제휴 업체
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>제공 목적</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        제공할 회원 정보의 내용 등을 사전에 공지하고 회원의 동의를 얻어야 합니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>
        회원정보 사용에 대한 자세한 사항은 개인정보 처리방침에서 확인하실 수
        있습니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>7</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회원정보의 변경
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회원은 개인정보 수정 화면을 통하여 언제든지 본인의 개인정보를 열람하고
        수정할 수 있습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>다만</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>서비스 관리를 위해 필요한 실명</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>생년월일</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>성별</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        아이디 등은 수정이 불가능합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회원은 회원가입 신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을
        하거나 기타 사항으로 회사에 대하여 그 변경사항을 알려야 합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>제</span>
      <span style={{ fontFamily: '"맑은 고딕"' }}>②</span>
      <span style={{ fontFamily: "굴림" }}>
        항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 회사는
        책임지지 않습니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>7</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회원 아이디와 비밀번호 관리에 대한 회원의 의무
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        아이디와 비밀번호에 관한 모든 관리책임은 회원에게 있습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>
        회원에게 부여된 아이디와 비밀번호의 관리소홀
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        부정사용에 의하여 발생하는 모든 결과에 대한 책임은 회원에게 있으며
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회사는 이에 대한 책임을 지지 않습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>다만</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회사의 고의 또는 과실로 인한 경우에는 그러하지 아니합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회원은 자신의 아이디가 부정하게 사용된 사실을 알게 될 경우 반드시 회사에
        그 사실을 통지하고 회사의 안내에 따라야 합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>제</span>
      <span style={{ fontFamily: '"맑은 고딕"' }}>②</span>
      <span style={{ fontFamily: "굴림" }}>
        항의 경우에 해당 회원이 회사에 그 사실을 통지하지 않거나
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        통지한 경우에도 회사의 안내에 따르지 않아 발생한 불이익에 대하여 회사는
        책임지지 않습니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>8</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      서비스의 종류
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사가 제공하는 서비스의 종류는 회사의 사정에 의하여 수시로 변경될 수
        있으며
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        제공되는 서비스에 대한 저작권 및 지식재산권은 회사에 귀속됩니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 서비스와 관련하여 회원에게 회사가 정한 이용조건에 따라 계정
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>아이디</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>서비스</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        포인트 등을 이용할 수 있는 이용권한만을 부여하며
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회원은 이를 활용한 유사 서비스 제공 및 상업적 활동을 할 수 없습니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>10</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      서비스의 내용
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 서비스의 종류에 따라 각 서비스의 특성
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        절차 및 방법에 대한 사항을 서비스 화면을 통하여 공지하며
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회원은 회사가 공지한 각 서비스에 관한 사항을 이해하고 서비스를 이용해야
        합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 상당한 이유가 있는 경우에 운영상
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        기술상의 필요에 따라 제공하고 있는 개별 서비스의 전부 또는 일부를
        변경하거나 종료할 수 있습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>이 경우 회사는 최소 </span>
      <span>7</span>
      <span style={{ fontFamily: "굴림" }}>
        일전에 해당 내용을 이용자에게 알립니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>11</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      서비스의 중지 등
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        서비스의 이용은 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴{" "}
      </span>
      <span>1</span>
      <span style={{ fontFamily: "굴림" }}>일 </span>
      <span>24</span>
      <span style={{ fontFamily: "굴림" }}>시간을 원칙으로 합니다</span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>
        다만 정기 점검 등의 필요로 회사가 사전에 고지하여 정한 날이나 시간은
        그러하지 않습니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 서비스를 일정범위로 분할하여 각 범위 별로 이용가능 시간을 별도로
        정할 수 있습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>
        이 경우 그 내용을 사전에 공지합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 다음 각 호에 해당하는 경우 서비스 제공을 중지할 수 있습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>
        이 경우 회사는 불가피한 경우가 아닌 한 서비스 제공 중지를 사전
        고지합니다
      </span>
      <span>.</span>
      <ol
        start={0}
        type={1}
        style={{ marginRight: "0pt", marginLeft: "0pt", paddingLeft: "0pt" }}
      >
        <li
          style={{
            marginLeft: "-4.24pt",
            marginBottom: "0pt",
            paddingLeft: "4.24pt"
          }}
        >
          <span style={{ fontFamily: "굴림" }}>
            서비스용 설비의 보수 등 공사로 인한 부득이한 경우
          </span>
        </li>
        <li
          style={{
            marginTop: "3pt",
            marginLeft: "-4.24pt",
            marginBottom: "0pt",
            paddingLeft: "4.24pt"
          }}
        >
          <span style={{ fontFamily: "굴림" }}>
            전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을
            경우
          </span>
        </li>
        <li
          style={{
            marginTop: "3pt",
            marginLeft: "-4.24pt",
            marginBottom: "0pt",
            paddingLeft: "4.24pt"
          }}
        >
          <span style={{ fontFamily: "굴림" }}>
            회사가 직접 제공하는 서비스가 아닌 제휴업체 등의 제
          </span>
          <span>3</span>
          <span style={{ fontFamily: "굴림" }}>
            자를 이용하여 제공하는 서비스의 경우 제휴 업체 등의 제
          </span>
          <span>3</span>
          <span style={{ fontFamily: "굴림" }}>
            자가 서비스를 중지했을 경우
          </span>
        </li>
        <li
          style={{
            marginTop: "3pt",
            marginLeft: "-4.24pt",
            marginBottom: "0pt",
            paddingLeft: "4.24pt"
          }}
        >
          <span style={{ fontFamily: "굴림" }}>
            기타 불가항력적 사유가 있는 경우
          </span>
        </li>
      </ol>
    </li>
  </ol>
  <p
    className="ListParagraph"
    style={{
      marginTop: "3pt",
      marginLeft: "36pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회사는 국가비상사태
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>정전</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스 이용에
      지장이 있는 때에는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있습니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>12</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      서비스 이용 제한 및 해지
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 다음 각 호의 경우 로그인을 차단하거나 거래
      </span>
      <span>∙</span>
      <span style={{ fontFamily: "굴림" }}>입금</span>
      <span>∙</span>
      <span style={{ fontFamily: "굴림" }}>
        출금을 중단 또는 지연하는 방법 등으로 회원의 서비스 이용을 제한할 수
        있습니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      className="ListParagraph"
      style={{
        marginLeft: "31.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>타인의 </span>
      <span>ID </span>
      <span style={{ fontFamily: "굴림" }}>
        또는 비밀번호를 도용하거나 개인정보를 사용한 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "31.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        서비스 운영을 고의로 방해한 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "31.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>가입한 이름이 실명이 아닌 경우</span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "31.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        형법 등 관계 법령을 위반하거나 사회적 공익을 저해할 목적으로 서비스를
        이용하는 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "31.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        타인의 개인정보를 무단으로 수집
      </span>
      <span>∙</span>
      <span style={{ fontFamily: "굴림" }}>저장</span>
      <span>∙</span>
      <span style={{ fontFamily: "굴림" }}>
        공개하거나 기타 타인의 정당한 권리를 침해하는 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "31.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        서비스의 안정적 운영을 방해할 목적으로 다량의 정보를 전송하거나 광고성
        정보를 전송하는 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "31.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        정보통신설비의 오작동이나 정보 등의 파괴를 유발시키는 컴퓨터 바이러스
        프로그램 등을 유포하는 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "31.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사의 서비스를 이용하여 얻은 정보를 회사의 사전 승낙없이 복제 또는
        유통하거나 상업적으로 이용하는 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "31.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        같은 사용자가 회사의 정책에 반하여 복수의{" "}
      </span>
      <span>ID</span>
      <span style={{ fontFamily: "굴림" }}>를 등록한 경우</span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "36pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>회원이 미성년자인 경우</span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "36pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>해킹</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>계정탈취</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>명의도용</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>사기</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>보이스피싱 등의 범죄</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>자금세탁</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        기타 이와 유사한 불법행위 등과 관련 있거나 관련성이 있다고 합리적으로
        의심되는 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "36pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>통정매매</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>가장매매</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>시세조종</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>부정거래행위</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>시장질서 교란행위</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        기타 회사와의 합의를 위반하는 행위 등과 관련 있거나 관련성이 있다고
        합리적으로 의심되는 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "36pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        전호의 사유로 가상자산 또는 원화를 취득한 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "36pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>민사소송</span>
      <span>∙</span>
      <span style={{ fontFamily: "굴림" }}>
        집행법이나 형사소송법 등의 관련 법령에 따라 서비스 제한을 요청 받는 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "36pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        국가기관 또는 금융기관으로부터 회원의 계정이 불법행위에 이용된 것으로
        의심된다는 정보의 제공이 있는 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "36pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>입</span>
      <span>∙</span>
      <span style={{ fontFamily: "굴림" }}>출금 정보의 오기</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        금융사고 등으로 인해 타인의 가상자산 또는 원화를 권한 없이 취득하거나
        전송 받는 경우
      </span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "36pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 회원의 서비스 이용을 제한하고자 하는 경우에는 그 사유
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        일시 및 기간을 정하여 이 약관 제
      </span>
      <span>9</span>
      <span style={{ fontFamily: "굴림" }}>
        조에서 정한 방법을 이용하여 해당 회원에게 통지합니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>다만</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        긴급하게 서비스 이용을 제한하여야 할 필요가 있다고 인정되는 경우
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회사는 사전 통지없이 서비스 이용을 제한할 수 있습니다
      </span>
      <span>.</span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "36pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회원은 회사의 서비스 이용 제한에 대해 이의를 제기할 수 있습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>
        회사는 회원의 서비스 이용 제한 사유가 해소되는 경우 지체없이 서비스 이용
        제한을 해지합니다
      </span>
      <span>.</span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "36pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 회원의 서비스 이용 제한 사유가 발생할 경우 이를 해결하기 위해
        노력합니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>다만</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        서비스 이용 제한 사유가 해소되지 않는 경우 회사는 상당한 기간을 정하여
        회원에게 최고 후 이용계약을 해지할 수 있습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>
        회원은 회사의 이용계약 해지에 대해 이의를 제기 할 수 있습니다
      </span>
      <span>.</span>
    </li>
    <li
      className="ListParagraph"
      style={{
        marginTop: "3pt",
        marginLeft: "36pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회원이 이용계약을 해지하고자 할 때에는 자신의 모든 자산
      </span>
      <span>(</span>
      <span style={{ fontFamily: "굴림" }}>가상자산과 원화</span>
      <span>)</span>
      <span style={{ fontFamily: "굴림" }}>
        을 출금한 후 회사에 해지 신청을 하여야 합니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "3pt",
      marginLeft: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span
      style={{ fontFamily: "Arial", fontSize: "10.5pt", AwImport: "ignore" }}
    >
      &nbsp;
    </span>
  </p>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>13</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      개인정보의 보호
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회사는 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해
      노력합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>. </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회원의 개인정보는 서비스의 원활한 제공을 위하여 회원이 동의한 목적과 범위
      내에서만 이용됩니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>. </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회사는 법령에 의하거나 회원이 별도로 동의하지 아니하는 한
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회원의 개인정보를 제
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>3</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      자에게 제공하지 아니하며
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이에 대한 자세한 사항은 개인정보 처리방침에서 정합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>14</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회사의 면책사항 및 손해배상
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 서비스와 관련하여 이 약관에 명시되지 않은 어떠한 사항에 대하여
        보증을 하지 않습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>또한</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회사는 회사가 발행하거나 지급을 보증하지 아니한 가상자산의 가치를
        보증하지 않습니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>회사는 천재지변</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>디도스</span>
      <span>(DDos) </span>
      <span style={{ fontFamily: "굴림" }}>공격</span>
      <span>, IDC</span>
      <span style={{ fontFamily: "굴림" }}>장애</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        서비스 접속의 폭등으로 인한 서버 다운
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        기간통신사업자의 회선 장애 등 기타 불가항력적인 사유로 서비스를 제공할
        수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>다만</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회사의 고의 또는 과실이 있는 경우에는 그러하지 아니합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 회원의 귀책사유로 인한 서비스 이용 장애나 그 결과에 대하여는
        책임을 지지 않습니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>다만</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회사의 고의 또는 과실이 있거나 회원에게 정당한 사유가 있는 경우에는
        그러하지 아니합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>회사는 회원간 또는 회원과 제</span>
      <span>3</span>
      <span style={{ fontFamily: "굴림" }}>
        자 상호간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다
      </span>
      <span>. </span>
      <span style={{ fontFamily: "굴림" }}>다만</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회사의 고의 또는 과실이 있는 경우에는 그러하지 아니합니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이
        없거나 회사의 고의 또는 과실이 없는 한 책임을 지지 않습니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>누구든지 서비스 오류</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        전산장애 또는 기타 사유로 인하여 제
      </span>
      <span>3</span>
      <span style={{ fontFamily: "굴림" }}>
        자 소유의 가상자산을 권한 없이 취득하거나 전송 받게 될 경우
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회사는 당사자에게 사전 통지 후 해당 가상자산을 회수하거나 원상회복
        시키는 등 필요한 조치를 취할 수 있습니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>15</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      대리 및 보증의 부인
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 회원을 대리하는 권한을 가지고 있지 않으며
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회사의 어떠한 행위도 회원을 위한 대리행위로 간주되지 않습니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        회사는 회사가 제공하는 서비스를 통하여 이루어지는 회원 간의 거래와
        관련하여 거래 의사의 존재 여부 및 진위
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        적법성에 대하여 보증하지 않습니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>16</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      관할법원 및 준거법
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        본 서비스 이용 약관은 대한민국 법률에 따라 규율되고 해석되며
      </span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        회사의 요금체계 등 서비스 이용과 관련하여 회사와 회원 간에 발생한
        분쟁으로 소송이 제기되는 경우 대한민국 법률이 적용됩니다
      </span>
      <span>.</span>
    </li>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        서비스 이용과 관련하여 회사와 회원 간에 발생한 소송의 경우 법령에 정한
        절차에 따른 법원을 관할 법원으로 합니다
      </span>
      <span>.</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>부칙</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>이 약관은 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>2023</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>년 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>8</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>월 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>14</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      일부터 적용됩니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p>
    <span style={{ AwImport: "ignore" }}>&nbsp;</span>
  </p>
  <p>
    <span style={{ AwImport: "ignore" }}>&nbsp;</span>
  </p>
</div>

            </div>
        </div>
    );
}

function TermSecound({ setPopUp }) {
    
    const divStyle = {
        overflowY: 'auto',   // 세로 스크롤을 허용
        maxHeight: '500px',  // 최대 높이 설정 (스크롤이 필요한 경우에만 나타나게 함)
        border: '1px solid #ccc', // 선택적으로 테두리를 추가할 수 있음
      };

      

    return (
        <div className="popup_01 popup_term2" >
            <div className="popup_inner01" style={divStyle}>
                <div className="popup_header">
                    <h3>{getLocaleWordContent('개인정보 수집 및 이용 동의 (필수)')}</h3>
                    <img src={img_close} className="popup_close" alt="close" onClick={() => setPopUp(0)} />
                </div>
                <div className="popup_body">
                <div>
  <p style={{ textAlign: "left", lineHeight: "22.5pt", widows: 2, orphans: 2 }}>
    <span style={{ fontFamily: "굴림", fontSize: "15pt", color: "#1b1b1b" }}>
      개인정보 수집 및 이용 동의{" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "15pt", color: "#1b1b1b" }}>
      (
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "15pt", color: "#1b1b1b" }}>
      필수
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "15pt", color: "#1b1b1b" }}>
      )
    </span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", backgroundColor: "#ffffff" }}>(</span>
    <span style={{ backgroundColor: "#ffffff" }}>주</span>
    <span style={{ fontFamily: "Arial", backgroundColor: "#ffffff" }}>)</span>
    <span style={{ backgroundColor: "#ffffff" }}>메가아즈위</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      {" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      이하{" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ‘
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회사
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ’)
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      가 제공하는 서비스를 이용하시는 분께
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      이하{" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ‘
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      고객
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ’){" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      개인정보의 이용목적 및 수집항목
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      개인정보의 보유 및 이용기간
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      동의 거부권 및 동의 거부 시 불이익에 관한 사항을 안내 드리오니 자세히 읽은
      후 동의하여 주시기 바랍니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .
    </span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span
      style={{
        fontFamily: "굴림",
        fontSize: "10.5pt",
        fontWeight: "bold",
        color: "#777777"
      }}
    >
      동의 거부권 및 동의 거부 시 불이익에 관한 사항
    </span>
    <span
      style={{
        fontFamily: "Arial",
        fontSize: "10.5pt",
        fontWeight: "bold",
        color: "#777777"
      }}
    >
      :{" "}
    </span>
    <span
      style={{
        fontFamily: "굴림",
        fontSize: "10.5pt",
        fontWeight: "bold",
        color: "#777777"
      }}
    >
      개인정보 수집
    </span>
    <span
      style={{
        fontFamily: "Arial",
        fontSize: "10.5pt",
        fontWeight: "bold",
        color: "#777777"
      }}
    >
      /
    </span>
    <span
      style={{
        fontFamily: "굴림",
        fontSize: "10.5pt",
        fontWeight: "bold",
        color: "#777777"
      }}
    >
      이용에 대한 동의를 거부하실 수 있으며
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      거부 시에는 회원가입에 제한을 받을 수 있습니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      단
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      마케팅 및 광고 활용을 위한 개인정보 수집
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      /
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      이용에 대한 동의를 거부하시는 경우에는{" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ‘
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      서비스
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ’{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      이용이 가능합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .
    </span>
  </p>
  <p
    style={{
      marginTop: "15pt",
      marginBottom: "15pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#ff8200" }}>
      개인정보의 이용목적 및 수집항목
    </span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ‘
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회사
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ’
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      는 개인정보를 다음의 목적을 위해 수집 및 이용합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .
    </span>
  </p>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>1. </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회원 가입 및 관리
    </span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회원 가입의사 확인
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회원 서비스 제공에 따른 본인 식별 및 인증
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회원자격 유지 및 관리
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      서비스 부정이용방지
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      서비스 고지 및 통지
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      고객지원을 위해 아래와 같은 개인정보를 수집합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      -{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      성명
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      생년월일
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      성별
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      휴대폰번호
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      연계정보
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (CI),{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      중복가입확인정보
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (DI),{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      국가번호
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      이메일 주소
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      비밀번호
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      거주지
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      주소
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      )
    </span>
  </p>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>2. ‘</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>고객</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>’ </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      본인확인 및 회원정보 변경 관리
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      -{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      성명
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      생년월일
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      성별
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      계좌번호
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      예금주
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ),{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      휴대폰 본인확인 정보
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      성명
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      생년월일
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      휴대폰번호
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ),{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      연계정보
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (CI),{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      중복가입확인정보
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (DI)
    </span>
  </p>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>3. </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>서비스 이용</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      서비스 이용과정에서 계정관리
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      자동생성
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      부가서비스 이용을 위해 아래와 같은 개인정보를 수집합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .
    </span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginTop: "3pt",
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt",
        color: "#777777"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>자동생성</span>
      <span>: </span>
      <span style={{ fontFamily: "굴림" }}>접속지 정보</span>
      <span>(IP </span>
      <span style={{ fontFamily: "굴림" }}>주소</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>일시</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>기기정보</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>브라우저</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>국가</span>
      <span>)</span>
    </li>
  </ol>
  <p
    style={{
      marginTop: "15pt",
      marginBottom: "15pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#ff8200" }}>
      개인정보의 보유 및 이용기간
    </span>
  </p>
  <p
    style={{
      marginBottom: "14pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ‘
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회사
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ’
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      는 관계법령에 따른 개인정보 보유 및 이용기간 또는 고객의 개인정보 수집
      시에 동의 받은 개인정보 보유 및 이용기간에 따라 개인정보를 처리하고
      있습니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "14pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ‘
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회사
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ’
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      는 아래와 같이 필요한 경우에만 개인정보를 보유 및 이용합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .
    </span>
  </p>
  <ol type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "14pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt",
        color: "#777777"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        가상자산서비스를 위한 개인정보 보유 및 이용기간
      </span>
    </li>
  </ol>
  <table
    cellSpacing={0}
    cellPadding={0}
    style={{
      width: "368.9pt",
      marginBottom: "0pt",
      border: "0.75pt solid #d5d5d5",
      borderCollapse: "collapse"
    }}
  >
    <tbody>
      <tr>
        <td
          style={{
            borderRight: "0.75pt solid #d5d5d5",
            borderBottom: "0.75pt solid #d5d5d5",
            paddingTop: "6pt",
            paddingBottom: "6pt",
            verticalAlign: "middle",
            backgroundColor: "#f7f7f7"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span
              style={{
                fontFamily: "굴림",
                fontSize: "9pt",
                fontWeight: "bold"
              }}
            >
              구분
            </span>
          </p>
        </td>
        <td
          style={{
            borderRight: "0.75pt solid #d5d5d5",
            borderLeft: "0.75pt solid #d5d5d5",
            borderBottom: "0.75pt solid #d5d5d5",
            paddingTop: "6pt",
            paddingBottom: "6pt",
            verticalAlign: "middle",
            backgroundColor: "#f7f7f7"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span
              style={{
                fontFamily: "굴림",
                fontSize: "9pt",
                fontWeight: "bold"
              }}
            >
              보유사유
            </span>
          </p>
        </td>
        <td
          style={{
            width: "123.9pt",
            borderLeft: "0.75pt solid #d5d5d5",
            borderBottom: "0.75pt solid #d5d5d5",
            paddingTop: "6pt",
            paddingBottom: "6pt",
            verticalAlign: "middle",
            backgroundColor: "#f7f7f7"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span
              style={{
                fontFamily: "굴림",
                fontSize: "9pt",
                fontWeight: "bold"
              }}
            >
              보유기간
            </span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          style={{
            borderTop: "0.75pt solid #d5d5d5",
            borderRight: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              회원 가입
            </span>
          </p>
        </td>
        <td
          style={{
            borderTop: "0.75pt solid #d5d5d5",
            borderRight: "0.75pt solid #d5d5d5",
            borderLeft: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              회원 관리
            </span>
          </p>
        </td>
        <td
          style={{
            width: "121.65pt",
            borderTop: "0.75pt solid #d5d5d5",
            borderLeft: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span
              style={{
                fontFamily: "굴림",
                fontSize: "11pt",
                fontWeight: "bold",
                color: "#f03232"
              }}
            >
              탈퇴 시
            </span>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <ol start={2} type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "14pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt",
        color: "#777777"
      }}
    >
      <span style={{ fontFamily: "굴림" }}>
        재화 또는 서비스 제공에 따른 법령에 의한 보존
      </span>
    </li>
  </ol>
  <table
    cellSpacing={0}
    cellPadding={0}
    style={{
      width: "368.9pt",
      marginBottom: "0pt",
      border: "0.75pt solid #d5d5d5",
      borderCollapse: "collapse"
    }}
  >
    <tbody>
      <tr>
        <td
          style={{
            borderRight: "0.75pt solid #d5d5d5",
            borderBottom: "0.75pt solid #d5d5d5",
            paddingTop: "6pt",
            paddingBottom: "6pt",
            verticalAlign: "middle",
            backgroundColor: "#f7f7f7"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span
              style={{
                fontFamily: "굴림",
                fontSize: "9pt",
                fontWeight: "bold"
              }}
            >
              구분
            </span>
          </p>
        </td>
        <td
          style={{
            borderRight: "0.75pt solid #d5d5d5",
            borderLeft: "0.75pt solid #d5d5d5",
            borderBottom: "0.75pt solid #d5d5d5",
            paddingTop: "6pt",
            paddingBottom: "6pt",
            verticalAlign: "middle",
            backgroundColor: "#f7f7f7"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span
              style={{
                fontFamily: "굴림",
                fontSize: "9pt",
                fontWeight: "bold"
              }}
            >
              보존항목
            </span>
          </p>
        </td>
        <td
          style={{
            borderRight: "0.75pt solid #d5d5d5",
            borderLeft: "0.75pt solid #d5d5d5",
            borderBottom: "0.75pt solid #d5d5d5",
            paddingTop: "6pt",
            paddingBottom: "6pt",
            verticalAlign: "middle",
            backgroundColor: "#f7f7f7"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span
              style={{
                fontFamily: "굴림",
                fontSize: "9pt",
                fontWeight: "bold"
              }}
            >
              관계법령
            </span>
          </p>
        </td>
        <td
          style={{
            width: "90.7pt",
            borderLeft: "0.75pt solid #d5d5d5",
            borderBottom: "0.75pt solid #d5d5d5",
            paddingTop: "6pt",
            paddingBottom: "6pt",
            verticalAlign: "middle",
            backgroundColor: "#f7f7f7"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span
              style={{
                fontFamily: "굴림",
                fontSize: "9pt",
                fontWeight: "bold"
              }}
            >
              보유기간
            </span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          style={{
            borderTop: "0.75pt solid #d5d5d5",
            borderRight: "0.75pt solid #d5d5d5",
            borderBottom: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              계약 또는 청약철회 등에 관한 기록
            </span>
          </p>
        </td>
        <td
          style={{
            border: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              주문번호
            </span>
            <span style={{ fontFamily: "Arial", fontSize: "9pt" }}>, </span>
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>회원</span>
            <span style={{ fontFamily: "Arial", fontSize: "9pt" }}>ID, </span>
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              주문유형
            </span>
            <span style={{ fontFamily: "Arial", fontSize: "9pt" }}>, </span>
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              주문시간
            </span>
            <span style={{ fontFamily: "Arial", fontSize: "9pt" }}>, </span>
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              주문상태
            </span>
            <span style={{ fontFamily: "Arial", fontSize: "9pt" }}>, </span>
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              주문금액 등 매도
            </span>
            <span style={{ fontFamily: "Arial", fontSize: "9pt" }}>·</span>
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              매수 또는 취소 정보
            </span>
          </p>
        </td>
        <td
          rowSpan={2}
          style={{ border: "0.75pt solid #d5d5d5", verticalAlign: "middle" }}
        >
          <p
            style={{
              marginBottom: "0pt",
              widows: 2,
              orphans: 2,
              fontSize: "9pt"
            }}
          >
            <span style={{ fontFamily: "Arial", AwImport: "ignore" }}>
              &nbsp;
            </span>
          </p>
        </td>
        <td
          style={{
            width: "88.45pt",
            borderTop: "0.75pt solid #d5d5d5",
            borderLeft: "0.75pt solid #d5d5d5",
            borderBottom: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span
              style={{
                fontFamily: "Arial",
                fontSize: "11pt",
                fontWeight: "bold",
                color: "#f03232"
              }}
            >
              5{" "}
            </span>
            <span
              style={{
                fontFamily: "굴림",
                fontSize: "11pt",
                fontWeight: "bold",
                color: "#f03232"
              }}
            >
              년
            </span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          style={{
            borderTop: "0.75pt solid #d5d5d5",
            borderRight: "0.75pt solid #d5d5d5",
            borderBottom: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              소비자의 불만 또는 분쟁처리에 관한 기록
            </span>
          </p>
        </td>
        <td
          style={{
            border: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>회원</span>
            <span style={{ fontFamily: "Arial", fontSize: "9pt" }}>ID, </span>
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>이름</span>
            <span style={{ fontFamily: "Arial", fontSize: "9pt" }}>, </span>
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              전화번호 등 불만 및 분쟁 처리 정보
            </span>
          </p>
        </td>
        <td
          style={{
            width: "88.45pt",
            borderTop: "0.75pt solid #d5d5d5",
            borderLeft: "0.75pt solid #d5d5d5",
            borderBottom: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span
              style={{
                fontFamily: "Arial",
                fontSize: "11pt",
                fontWeight: "bold",
                color: "#f03232"
              }}
            >
              3{" "}
            </span>
            <span
              style={{
                fontFamily: "굴림",
                fontSize: "11pt",
                fontWeight: "bold",
                color: "#f03232"
              }}
            >
              년
            </span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          style={{
            borderTop: "0.75pt solid #d5d5d5",
            borderRight: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              인터넷 로그기록 및 접속지 추적 자료
            </span>
          </p>
        </td>
        <td
          style={{
            borderTop: "0.75pt solid #d5d5d5",
            borderRight: "0.75pt solid #d5d5d5",
            borderLeft: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>회원</span>
            <span style={{ fontFamily: "Arial", fontSize: "9pt" }}>ID, </span>
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>접속</span>
            <span style={{ fontFamily: "Arial", fontSize: "9pt" }}>IP, </span>
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              접속 일시 등 통신사실 확인자료
            </span>
          </p>
        </td>
        <td
          style={{
            borderTop: "0.75pt solid #d5d5d5",
            borderRight: "0.75pt solid #d5d5d5",
            borderLeft: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span style={{ fontFamily: "굴림", fontSize: "9pt" }}>
              통신비밀보호법
            </span>
          </p>
        </td>
        <td
          style={{
            width: "88.45pt",
            borderTop: "0.75pt solid #d5d5d5",
            borderLeft: "0.75pt solid #d5d5d5",
            padding: "6pt 1.12pt",
            verticalAlign: "middle"
          }}
        >
          <p
            style={{
              marginBottom: "0pt",
              textAlign: "center",
              lineHeight: "13.5pt",
              widows: 2,
              orphans: 2
            }}
          >
            <span
              style={{
                fontFamily: "Arial",
                fontSize: "11pt",
                fontWeight: "bold",
                color: "#f03232"
              }}
            >
              3{" "}
            </span>
            <span
              style={{
                fontFamily: "굴림",
                fontSize: "11pt",
                fontWeight: "bold",
                color: "#f03232"
              }}
            >
              개월
            </span>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <ol start={3} type={1} style={{ margin: "0pt", paddingLeft: "0pt" }}>
    <li
      style={{
        marginLeft: "13.76pt",
        marginBottom: "0pt",
        textAlign: "left",
        lineHeight: "17.25pt",
        widows: 2,
        orphans: 2,
        paddingLeft: "4.24pt",
        fontFamily: "Arial",
        fontSize: "10.5pt",
        color: "#777777"
      }}
    >
      <span style={{ fontFamily: '"맑은 고딕"' }}>※</span>
      <span style={{ fontFamily: "굴림" }}> 단</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>사고 조사</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>분쟁해결</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>민원처리</span>
      <span>, </span>
      <span style={{ fontFamily: "굴림" }}>
        법령상 의무이행을 위한 경우 분리하여 별도 보관
      </span>
    </li>
  </ol>
  <p>
    <span style={{ AwImport: "ignore" }}>&nbsp;</span>
  </p>
</div>

        </div>
                </div>
                </div>
    );
}

export default function Terms() {
    const history = useHistory();
    const [popup, setPopUp] = useState(0);
    const [check, setCheck] = useState(false);

    const handleCheck = () => {
        if (check === true) {
            setCheck(false);
        } else {
            setCheck(true);
        }
    };
    const NextPage = () => {
        if (check === true) {
            const dataToSend = { check: 'true' }; // 전달하려는 데이터
            const queryString = new URLSearchParams(dataToSend).toString();
            history.push(`/signup?${queryString}`);
            
        } else {
            alert(getLocaleWordContent('약관에 동의해 주세요.'));
        }
    };
    
     
    const divStyle = {
      overflowY: 'auto',   // 세로 스크롤을 허용
      maxHeight: '500px',  // 최대 높이 설정 (스크롤이 필요한 경우에만 나타나게 함)
      border: '1px solid #ccc', // 선택적으로 테두리를 추가할 수 있음
    };
    
    return (
        <>
            {/* {popup === 1 ? <TermFirst setPopUp={setPopUp} /> : popup === 2 ? <TermSecound setPopUp={setPopUp} /> : null} */}
            <div className="terms">
                <h2 className="terms_tit text-center">Hi, Welcome to Aleo</h2>
                <p className="terms_txt text-center">{getLocaleWordContent('이용약관에 동의해주세요.')}</p>
                <form>
                    <input type="radio" name="check_term" checked={check} onChange={handleCheck} />
                    <label htmlFor="check_term">
                      <span style={{ fontFamily: "굴림", fontSize: "15pt", color: "#1b1b1b" }}> {getLocaleWordContent('약관에 모두 동의')}</span>
                    </label>
                </form>

                <ul>
                    <li>
                      <span style={{ fontFamily: "굴림", fontSize: "13pt", color: "#1b1b1b" }}> 만 19세 이상입니다. (필수)</span>
                    </li>
                    <li onClick={() => setPopUp(1)}>
                      <span style={{ fontFamily: "굴림", fontSize: "13pt", color: "#1b1b1b" }}> 서비스 이용약관 동의 (필수)</span>
                        {/* <span className="btn-r" id="openterm1" /> */}
                    </li>
                    <br/>
                    <div>
  
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>1</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>목적</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이 약관은 메가아즈위
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>이하</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>: </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>회사</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      가 제공하는 회원 서비스
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>이하</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>: </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>회원</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      의 이용조건 및 절차에 관한 회사와 회원 간의 권리 의무 및 책임사항
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      기타 필요한 사항을 규정함을 목적으로 합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>제</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>2</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>조 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>약관의 명시</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>설명과 개정</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이 약관의 내용은 회사의 서비스 회원가입 관련 사이트에 게시하거나 기타의
      방법으로 이용자에게 공지하고
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      이용자가 회원으로 가입하면서 이 약관에 동의함으로써 효력을 발생합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>회사는 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>"</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      약관의 규제에 관한 법률
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>", "</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      정보통신망 이용촉진 및 정보보호 등에 관한 법률
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>", "</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      특정 금융거래정보의 보고 및 이용 등에 관한 법률
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>" </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회사가 약관을 개정할 경우에는 적용일자 및 개정 사유를 명시하여 현행 약관과
      함께 회사 사이트의 초기화면이나 팝업화면 또는 공지사항으로 그 적용일자{" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>7</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      일 이전부터 공지합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>. </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>다만</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>, </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회원에게 불리하거나 중대한 내용의 변경의 경우에는 적용일
    </span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>반품</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>3</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>일전 수수료 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>3% 4</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>일부터 수당</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>(</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>판매</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>,</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>롤업</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>추천</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>지사</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      정산후차감하고
    </span>
    <span
      style={{ fontFamily: "굴림", fontSize: "10.5pt", AwImport: "spaces" }}
    >
      &nbsp;{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      한달내 지급하기로 한다
    </span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      탈퇴 회원은 수익 금액은{" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>100% </span>
    <span
      style={{ fontFamily: "Arial", fontSize: "10.5pt", AwImport: "spaces" }}
    >
      &nbsp;
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>p/s </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>로 적립한다</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>적립된</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>p/s p/t (</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      알레오 코인 상장 이후{" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>3</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      개월 후부터 현금 또는 알레오 코인{" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>12</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      개월동인 전회원
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>n/1</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>로 분배한다</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>)</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>부칙</span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>이 약관은 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>2023</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>년 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>8</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>월 </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>14</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      일부터 적용됩니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>.</span>
  </p>
  <p>
    <span style={{ AwImport: "ignore" }}>&nbsp;</span>
  </p>
  <p>
    <span style={{ AwImport: "ignore" }}>&nbsp;</span>
  </p>
</div>

      
      
                    <li onClick={() => setPopUp(2)}>
                      <span style={{ fontFamily: "굴림", fontSize: "13pt", color: "#1b1b1b" }}> 개인정보 수집 및 이용 동의 (필수)</span>
                    </li>
                    <br/>
                      <div>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", backgroundColor: "#ffffff" }}>(</span>
    <span style={{ backgroundColor: "#ffffff" }}>주</span>
    <span style={{ fontFamily: "Arial", backgroundColor: "#ffffff" }}>)</span>
    <span style={{ backgroundColor: "#ffffff" }}>메가아즈위</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      {" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      이하{" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ‘
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회사
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ’)
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      가 제공하는 서비스를 이용하시는 분께
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      이하{" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ‘
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      고객
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ’){" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      개인정보의 이용목적 및 수집항목
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      개인정보의 보유 및 이용기간
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      동의 거부권 및 동의 거부 시 불이익에 관한 사항을 안내 드리오니 자세히 읽은
      후 동의하여 주시기 바랍니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .
    </span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span
      style={{
        fontFamily: "굴림",
        fontSize: "10.5pt",
        fontWeight: "bold",
        color: "#777777"
      }}
    >
      동의 거부권 및 동의 거부 시 불이익에 관한 사항
    </span>
    <span
      style={{
        fontFamily: "Arial",
        fontSize: "10.5pt",
        fontWeight: "bold",
        color: "#777777"
      }}
    >
      :{" "}
    </span>
    <span
      style={{
        fontFamily: "굴림",
        fontSize: "10.5pt",
        fontWeight: "bold",
        color: "#777777"
      }}
    >
      개인정보 수집
    </span>
    <span
      style={{
        fontFamily: "Arial",
        fontSize: "10.5pt",
        fontWeight: "bold",
        color: "#777777"
      }}
    >
      /
    </span>
    <span
      style={{
        fontFamily: "굴림",
        fontSize: "10.5pt",
        fontWeight: "bold",
        color: "#777777"
      }}
    >
      이용에 대한 동의를 거부하실 수 있으며
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      거부 시에는 회원가입에 제한을 받을 수 있습니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      단
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      마케팅 및 광고 활용을 위한 개인정보 수집
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      /
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      이용에 대한 동의를 거부하시는 경우에는{" "}
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ‘
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      서비스
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ’{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      이용이 가능합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .
    </span>
  </p>
  <p
    style={{
      marginTop: "15pt",
      marginBottom: "15pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#ff8200" }}>
      개인정보의 이용목적 및 수집항목
    </span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ‘
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회사
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ’
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      는 개인정보를 다음의 목적을 위해 수집 및 이용합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .
    </span>
  </p>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>1. </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      회원 가입 및 관리
    </span>
  </p>
  <p
    style={{
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회원 가입의사 확인
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회원 서비스 제공에 따른 본인 식별 및 인증
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      회원자격 유지 및 관리
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      서비스 부정이용방지
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      서비스 고지 및 통지
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      고객지원을 위해 아래와 같은 개인정보를 수집합니다
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      .
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      -{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      성명
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      휴대폰번호
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      연계정보
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (CI),{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      중복가입확인정보
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (DI),
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      비밀번호
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,
    </span>
  </p>
  <p
    style={{
      marginTop: "18pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "15.75pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>2. ‘</span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>고객</span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt" }}>’ </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt" }}>
      본인확인 및 회원정보 변경 관리
    </span>
  </p>
  <p
    style={{
      marginTop: "3pt",
      marginBottom: "0pt",
      textAlign: "left",
      lineHeight: "17.25pt",
      widows: 2,
      orphans: 2
    }}
  >
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      -{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      성명
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      계좌번호
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      예금주
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ),{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      휴대폰 본인확인 정보
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      성명
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ,
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      휴대폰번호
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      ),{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      연계정보
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (CI),{" "}
    </span>
    <span style={{ fontFamily: "굴림", fontSize: "10.5pt", color: "#777777" }}>
      중복가입확인정보
    </span>
    <span style={{ fontFamily: "Arial", fontSize: "10.5pt", color: "#777777" }}>
      (DI)
    </span>
  </p>
</div>
                </ul>
                <div className="sub_btn_box">
                    <input
                        type="button"
                        className={check === true ? 'btn01' : 'btn02'}
                        defaultValue="Next"
                        onClick={NextPage}
                    />
                </div>
            </div>
        </>
    );
}
